export default (el, callback) => {
  const handleKeyEvent = (event) => {
    if (event.key === "Escape") {
      unBindEvents();
      callback(true); // true => focus needs to be moved
    }
  };

  const handleClickEvent = (event) => {
    if (!el.contains(event.target)) {
      unBindEvents();
      callback(false);
    }
  };

  const bindEvents = () => {
    document.addEventListener("keydown", handleKeyEvent);
    document.addEventListener("click", handleClickEvent);
    document.addEventListener("focusin", handleClickEvent);
  };

  const unBindEvents = () => {
    document.removeEventListener("keydown", handleKeyEvent);
    document.removeEventListener("click", handleClickEvent);
    document.removeEventListener("focusin", handleClickEvent);
  };

  bindEvents();
};
